import { render, staticRenderFns } from "./CreateProductOrder.vue?vue&type=template&id=20af06b6"
import script from "./CreateProductOrder.vue?vue&type=script&lang=js"
export * from "./CreateProductOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateProductOrder.vue?vue&type=style&index=0&id=20af06b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports